/**
 * Identity
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchPermissionGrantsResponseItem } from './search-permission-grants-response-item';


export interface SearchPermissionGrantsResponseItemPagedList { 
    totalCount?: number;
    items?: Array<SearchPermissionGrantsResponseItem> | null;
}

